module.exports = "/_next/static/images/tr-657ea685af5d36cee81415a10303e5bb.svg";